import { render, staticRenderFns } from "./payslipItsheet.vue?vue&type=template&id=6eec5fb0&scoped=true"
import script from "./payslipItsheet.vue?vue&type=script&lang=js"
export * from "./payslipItsheet.vue?vue&type=script&lang=js"
import style0 from "./payslipItsheet.vue?vue&type=style&index=0&id=6eec5fb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eec5fb0",
  null
  
)

export default component.exports